export enum TipoSituacao {
  Pago = 1,
  Aberto = 2,
  Isento = 3,
  Inadimplente = 4,
  InadimplenteBloqueado = 5,
  Residual = 6,
  Cancelado = 8,
  SegundaVia = 9
}

export enum TipoAcordo {
  Acordo = 0,
  AgrupamentoParcelas = 1
}

export enum RetornoCartao {
  Sucesso = 1,
  NaoAutorizado = 2,
  Expirado = 3,
  Bloqueado = 4,
  Timeout = 5,
  Cancelado = 6,
  DadosInvalidos = 7,
  JaConfirmado = 8,
  LimiteExcedido = 9,
  ValidadeExpirada = 10,
  CvvInvalido = 11
}
